import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Veículo',
    path: '/transporte/traveiculo',
    name: 'traveiculo',
    component: () => import('@/views/transporte/traveiculo/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.VEICULOSNOVO_MENU_1100200299],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Veículo',
    parent: 'traveiculo',
    path: '/transporte/traveiculo/cadastro/:id?',
    name: 'traveiculo-create',
    component: () => import('@/views/transporte/traveiculo/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.VEICULOSNOVO_MENU_1100200299],
    },
    goesToMenu: false,
  },
];
